<template>
  <div
    :class="{
      'deck-exodia-header-image': true,
      [`deck-exodia-header-image--${size}`]: true,
      [`deck-exodia-header-image--profile-spacer`]: floatProfileImage,
      [`deck-exodia-header-image--extra-profile-spacer`]: floatProfileImage && extraProfileSpacer,
    }"
  >
    <v-img
      v-if="showCoverImage && coverImageUrl"
      v-test-id="'deck-exodia-header-cover-image'"
      :class="headerCoverImageClasses"
      :src="coverImageUrl"
      :cover="!coverImageContain"
    >
      <template v-if="fallbackCoverImageUrl" #error>
        <v-img
          :src="fallbackCoverImageUrl"
          :aspect-ratio="1"
          :cover="!coverImageContain"
        />
      </template>
    </v-img>
    <div
      v-else-if="size !== 'small'"
      :class="headerCoverImageFallbackStyle"
    />

    <template v-if="isProfile">
      <v-img
        v-if="showProfileImage && profileImageUrl"
        v-test-id="'deck-exodia-header-profile-image'"
        :src="profileImageUrl"
        :aspect-ratio="1"
        :class="profileImageClasses"
        :cover="!profileImageContain"
      />
      <DeckExodiaProfileImageFallback
        v-else
        v-test-id="'deck-exodia-header-profile-image-fallback'"
        :class="profileImageClasses"
        :text="title"
        :rounded="showProfileImage"
        :aspect-ratio="1"
      />
    </template>
  </div>
</template>

<script>
import DeckExodiaProfileImageFallback from './_profile-image-fallback';

export default {
  name: 'DeckExodiaHeaderImage',
  components: {
    DeckExodiaProfileImageFallback,
  },
  props: {
    coverImageUrl: { type: String, default: null },
    fallbackCoverImageUrl: { type: String, default: null },
    profileImageUrl: { type: String, default: null },
    showCoverImage: { type: Boolean, default: false },
    showProfileImage: { type: Boolean, default: false },
    title: { type: String, default: null },
    size: { type: String, required: true },
    coverImageContain: { type: Boolean, default: false },
    profileImageContain: { type: Boolean, default: false },
    extraProfileSpacer: { type: Boolean, default: false },
  },
  computed: {
    style() {
      return this.showProfileImage ? 'profile' : 'cover';
    },
    isProfile() {
      return this.style === 'profile';
    },
    headerCoverImageClasses() {
      return {
        'deck-exodia-header-image__cover': true,
        [`deck-exodia-header-image__cover--${this.style}`]: true,
        [`deck-exodia-header-image__cover--${this.size}`]: true,
      };
    },
    headerCoverImageFallbackStyle() {
      return {
        ...this.headerCoverImageClasses,
        'deck-exodia-header-image__cover-fallback': true,
      };
    },
    profileImageClasses() {
      return {
        'deck-exodia-header-image__profile-image': true,
        [`deck-exodia-header-image__profile-image--${this.size}`]: true,
        'deck-exodia-header-image__profile-image--float': this.floatProfileImage,
      };
    },
    floatProfileImage() {
      return this.style === 'profile' && this.size !== 'small';
    },
  },
};
</script>

<style lang="scss">
$deck-exodia-header-image-float-bottom: 20px;

.deck-exodia-header-image {
  --deck-exodia-header-cover-height: 164px;
  --deck-exodia-header-image-floating-bottom: 20px;

  position: relative;
}

.deck-exodia-header-image--profile-spacer {
  margin-bottom: var(--deck-exodia-header-image-floating-bottom);
}

.deck-exodia-header-image--extra-profile-spacer {
  margin-bottom: calc(
    (var(--deck-exodia-header-cover-height) / 2)
    - var(--deck-exodia-header-image-floating-bottom)
  );
}

.deck-exodia-header-image--small {
  padding: var(--deck-exodia-padding);
}

.deck-exodia-header-image__cover {
  height: var(--deck-exodia-header-cover-height);
}

.deck-exodia-header-image__cover--small.deck-exodia-header-image__cover--profile {
  display: none !important;
}

.deck-exodia-header-image__cover-fallback {
  align-items: center;
  background-color: rgb(var(--v-theme-primary));
  background-position: 50% center;
  background-size: cover;
  opacity: 0.12;
  display: flex;
  justify-content: center;
  flex-grow: 1;
}

.deck-exodia-header-image__cover--cover {
  --deck-exodia-header-cover-height: 184px;

  &.deck-exodia-header-image__cover--small {
    --deck-exodia-header-cover-height: 142px;
    border-radius: var(--z-border-radius-inner-base);
    width: calc(100% - (var(--deck-exodia-padding) * 2));
  }
}

.deck-exodia-header-image__profile-image {
  border-radius: var(--z-border-radius-inner-base);
  height: 150px;
  left: calc(var(--deck-exodia-padding) + 8px);
  position: relative;
  width: 150px !important;
  z-index: 1;
}

.deck-exodia-header-image__profile-image--float {
  position: absolute;
  bottom: calc(var(--deck-exodia-header-image-floating-bottom) * -1);

  @media (max-width: 600px) {
    left: 50%;
    transform: translateX(-50%);
  }
}

.deck-exodia-header-image__profile-image--small {
  aspect-ratio: 1;
  height: unset;
  width: 100% !important;
  left: unset;
}
</style>
